import { ProviderModel } from '../../../data/entities';
import { useProviderSelection } from '../hooks/useProviderSelection';
import ProviderItem from './ProviderItem';
import style from '../styles/Provider.module.scss';

interface ProviderSelectionProps {
  providers: ProviderModel[];
  onSelectProvider: (provider: ProviderModel) => void;
  showAnyProvider?: boolean;
  onSelectAnyProvider?: () => void;
}

export const ProviderSelection = ({ providers, onSelectProvider, showAnyProvider, onSelectAnyProvider }: ProviderSelectionProps) => {
  const { selectedProviderId, anySelected, handleProviderClick, handleAnyProviderClick } = useProviderSelection(
    onSelectProvider,
    providers,
    onSelectAnyProvider,
    showAnyProvider
  );

  if (providers.length === 0 && !showAnyProvider)
    return <div>No providers available for this service.</div>;

  return (
    <div>
      {showAnyProvider && (
        <div
          onClick={handleAnyProviderClick}
          className={`${style.provider} ${anySelected ? style.selected : ''}`}
        >
          <div
            className={`${style.providerImage} d-flex align-items-center justify-content-center rounded-circle`}
            style={{ backgroundColor: '#f7bc9e', flexShrink: 0 }}
          >
            <i className="fa fa-users text-white" style={{ fontSize: '1.2rem' }} />
          </div>
          <span>Any Provider</span>
        </div>
      )}
      {providers.map((provider) => (
        <ProviderItem
          key={provider.id}
          provider={provider}
          isSelected={selectedProviderId === provider.id}
          onClick={() => handleProviderClick(provider)}
        />
      ))}
    </div>
  );
};

export default ProviderSelection;